import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import { toast } from "@/components/ui/UseToast";
const { VITE_MAX_IDLE_TIME } = import.meta.env;
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "@/app/store";
import { logout } from "@/features/auth/AuthSlice";
import { useUpdateCounterOccupiedStatusMutation } from "../services/CounterApi";
import { useSelector } from "react-redux";


const IdleLogoutHandler = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state: RootState) => state.auth);
  const [updateCounterStatus] = useUpdateCounterOccupiedStatusMutation();
  
  const handleOnIdle =async () => {
    const isAuthenticated = Boolean(localStorage.getItem("userToken"));
    if (!isAuthenticated) return; // Do nothing if the user is not logged in
    

     // Check if user has an open counter that needs to be closed
    const isCounterOpen = localStorage.getItem("counter_open") === "true";
    const isOccupied = localStorage.getItem("is_occupied") === "true";

    // Close the counter if it's open and occupied by current user
    if (isCounterOpen && isOccupied && userInfo?.counter_id && userInfo?.id) {
      try {
        await updateCounterStatus({
          id: userInfo.counter_id,
          staff_id: userInfo.id,
        }).unwrap();

        // Update local storage
        localStorage.setItem("is_occupied", "false");
        localStorage.setItem("counter_open", "false");

        console.log("Counter closed due to idle timeout");
      } catch (error) {
        console.error("Failed to close counter on idle logout:", error);
        // Continue with logout even if counter closing fails
      }
    }
    dispatch(logout());

    toast({
      variant: "destructive",
      title: "Session Timeout",
      description: "Session Timeout due to inactivity.",
    });
    navigate("/login");
  };

  const timer = VITE_MAX_IDLE_TIME * 60 * 1000;
  useIdleTimer({
    timeout: timer, // 15 minutes in milliseconds
    onIdle: handleOnIdle,
    debounce: 100, // Debounce the idle state to prevent flickering
    events: ["mousemove", "keydown", "wheel", "scroll", "touchstart"], // Common idle detection events
  });

  return null; // This component doesn't render anything
};

export default IdleLogoutHandler;
